import axios from 'axios'
import * as Config from '../config'
import { data } from 'autoprefixer'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminScanCenterToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  commonApi: {
    //upload image
    postImage: (props) =>
      axios.post(`${Config.UPLOAD_IMAGE}?s3_path=${props.path}`, props.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  },

  authApi: {
    loginApiScanCenter: ({ data, headers }) => {
      console.log(data, headers) // Corrected 'heder' to 'headers'
      return instance.post(Config.LOGIN_SCAN_CENTER, data, { headers })
    },
  },

  manageScanCenter: {
    // get Scan Categories Data
    getListScanCategoryData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.SCAN_CATEGORY_LISTING}${queryString}`

      return instance.get(url)
    },

    getScanCategoryDetails: ({ id }) =>
      instance.get(`${Config.SCAN_CATEGORY_LISTING}?scan_category_id=${id}`),

    addScanCategoryData: (data) => instance.post(Config.ADD_SCAN_CATEGORY, data),
    updateScanCategoryData: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_SCAN_CATEGORY}${id}/`, data),
    deleteScanCategoryData: ({ id }) => instance.delete(`${Config.DELETE_SCAN_CATEGORY}${id}/`),

    // get Scan Test List
    getListScanTestData: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.SCAN_TEST_LISTING}${queryString}`

      return instance.get(url)
    },
    addScanTestData: (data) => instance.post(Config.ADD_SCAN_TEST, data),
    updateScanTest: ({ id, ...data }) => instance.put(`${Config.UPDATE_SCAN_TEST}${id}/`, data),
    deleteScanTest: ({ id }) => instance.delete(`${Config.DELETE_SCAN_TEST}${id}/`),
  },
}
